/**
 * Adapted from wll8/try-it.
 */
import $ from 'jquery'
import * as scrollTo from 'jquery.scrollto' //leave this, even though we don't use it we need it available locally.

export function trySwagger(cfg) {
    $(cfg.authBtnPosSelector).after($(
        `<div class="${$(`a[href*="swagger.yaml"]:eq(0)`).attr(`class`)} btn setAuth">` + cfg.authBtnText + `</div>`
    ))
    $(`.btn.setAuth`).on('click', () => {
        // The pop-up window in swaggerBox can be displayed, but the swaggerBox itself is hidden
        console.log('called the event')
        const $swaggerBox = $(`.swaggerBox`)
            .removeClass(`hide`)
            .css({
                visibility: `hidden`,
                height: ``,
                left: ``,
                top: ``,
                width: ``,
            })

        let locked = $(`.swagger-ui .auth-wrapper .authorize.locked`)
        let unlocked = $(`.swagger-ui .auth-wrapper .authorize.unlocked`)
        if(locked) locked.click() // Open the pop-up window for setting auth
        if(unlocked) unlocked.click()

        const $modal = $(`.swagger-ui .dialog-ux .modal-ux`)
        
        $modal.css({ visibility: `visible` })

        $(`.swagger-ui .auth-btn-wrapper .btn-done, .swagger-ui .dialog-ux .modal-ux-header .close-modal`).click(() => {
            $swaggerBox.addClass(`hide`).css({ visibility: `` })
            $modal.css({ visibility: `` })
        });
    })

    // Add try button
    $(`.http-verb`).before(`
        <button class="tryBtn">${cfg.tryText}</button>
    `)
    $(`.tryBtn`).on('click', function (event) {
        event.stopPropagation()

        const $tryBtn = $(this)

        $(`.swaggerShadow`).remove() // First clear all temporary elements

        const $operation = $tryBtn.parents(`[data-section-id]`) // Get the outermost api box

        if ($operation.hasClass(`try`) === true) { // If the current API is already in the try state, uninstall and exit the function
            $(`.swaggerBox`).addClass(`hide`).removeClass(`show`)
            $operation.removeClass(`try`)
            return false
        }

        $(`[data-section-id]`).removeClass(`try`) // Delete the try class name of all other APIs
        $operation.addClass(`try`) // Add try class name to the currently clicked api

        // The following 3 lines add class names to some necessary elements to facilitate acquisition or identification
        $(`.try>div>div:nth-child(2)`).addClass(`apiBlock`)
        $(`.try .apiBlock>div:nth-child(1)`).addClass(`fullApiBox`)
        $(`.try .apiBlock>div>button`).addClass(`fullApi`)


        const appendSwaggerShadow = () => $(`.try .fullApiBox`).append(`<div class="swaggerShadow"></div>`) // Add a swaggerShadow element to synchronize the height of swagger and use it to occupy space
        // If cfg.trySwaggerInApi === true then swaggerShadow will be added under fullApi, otherwise it may be under reqBox
        if (cfg.trySwaggerInApi === true) {
            appendSwaggerShadow()
        } else {
            const requestSel = `.try .apiBlock h3`

            $(requestSel).parent().addClass(`reqBox`)

            if ($(requestSel).length && $(requestSel).text().includes(`Request`)) {
                $(`.try .reqBox`).append(`<div class="swaggerShadow"></div>`)
            } else {
                appendSwaggerShadow()
            }
        }

        // get the click method and api
        const fullApi = $(`.try .fullApi`).text().replace(cfg.tryText, '').trim()
        const [, method, api] = fullApi.match(/(\w+)(.*)/)

        // Get the position of swaggerShadow
        let pos = {}
        pos = getAbsolutePosition($(`.try .swaggerShadow`)[0])
        pos = Object.keys(pos).reduce((prev, cur, index) => { // Add px to the number without unit, undefined when the number is 0
            const val = pos[cur]
            return {
                ...prev,
                [cur]: typeof (val) === `number` ? (val > 0 ? `${val}px` : undefined) : val,
            }
        }, {})

        let oldHeight = pos.height ? `${pos.height}` : undefined

        // Move swagger to the position of swaggerShadow
        const getSwaggerBoxHeight = () => getAbsolutePosition($(`.swaggerBox`)[0]).height + `px`
        $(`.swaggerBox`).css({
            left: `${pos.left}`,
            top: `${pos.top}`,
            width: `${pos.width}`,
            height: oldHeight,
        }).removeClass(`hide`).addClass('show')

        // Synchronize the size of swaggerShadow to make it as big as swaggerBox
        $(`.swaggerShadow`).css({
            height: getSwaggerBoxHeight()
        })

        // scroll the swagger view to the same api position
        const selStr = `.opblock-summary-${method} [data-path="${api}"]`
        const $swaggerApiDom = $(selStr)
        const $opblock = $swaggerApiDom.parents(`.opblock`) // Get the currently clicked swagger api, and it is not an expanded element
        if ($opblock.hasClass(`open`) === false) {
            $swaggerApiDom.click() // turn on
            setTimeout(() => $('.response-col_status').remove(), 2000) //fix indent?
        }
        $opblock.addClass(`open`)
        $(`.swaggerBox`).scrollTo($swaggerApiDom.parent())
        function changeFn() {
            const pos = getAbsolutePosition($opblock[0])
            if (pos.height === 0) {
                return false; // The height is 0, no processing
            } else {
                let newHeight = `${pos.height}px`
                if (oldHeight !== newHeight) {
                    $(`.swaggerBox`).scrollTo($swaggerApiDom.parent())
                    $(`.swaggerBox`).css({
                        height: newHeight,
                    })
                    $(`.swaggerShadow`).css({
                        height: getSwaggerBoxHeight()
                    })
                    oldHeight = newHeight
                }
            }
        }

        const observer = new MutationObserver(changeFn)
        observer.disconnect()
        observer.observe($opblock[0], {
            attributes: true,
            childList: true,
            subtree: true,
        })
    })

    // When changing the browser window size, reset the state of swaggerBox
    $(window).resize(debounce(() => {
        $(`.swaggerBox`).addClass(`hide`).removeClass(`show`).css({ left: 0, top: 0 })
        $(`[data-section-id^="operation/"]`).removeClass(`try`)
    }, 500))
}


function debounce(fn, wait) { // anti-shake
  let timer = null
  return function () {
    if (timer !== null) {
      clearTimeout(timer)
    }
    timer = setTimeout(fn, wait)
  }
}

function getAbsolutePosition(domObj) { // Get element position and size
    // If the function has no value, the return object is empty
    if (!domObj) return null;
    const width = domObj.offsetWidth
    const height = domObj.offsetHeight
    // Start traversing outward from the target element, accumulate top and left values
    let top, left

    for (top = domObj.offsetTop, left = domObj.offsetLeft; domObj = domObj.offsetParent;) {
        top += domObj.offsetTop
        left += domObj.offsetLeft
    }
    const right = document.body.offsetWidth - width - left
    const bottom = document.body.offsetHeight - height - top

    // Returns the coordinate set of positioned elements
    return { width, height, top, left, right, bottom }
}
